export const translations = {
  es: {
    menu: {
      inicio: 'Inicio',
      acerca: 'Acerca del Diócesis',
      noticias: 'Noticias',
      convocatorias: 'Convocatorias',
      gaceta: 'Gaceta',
      transparencia: 'Transparencia',
      contacto: 'Contacto'
    },
    home: {
      titulo: 'Diócesis de Ipiales',
      subtitulo: 'Trabajando por nuestro municipio',
      anuncios: 'Anuncios Importantes',
      buscar: 'Encuentra lo que necesitas en segundos',
      accesoRapido: 'Acceso Rápido',
      contacto: 'Contacto',
      gaceta: 'Gaceta',
      noticias: 'Noticias y Publicaciones',
      ubicacion: 'Ubicación Diócesis de Ipiales'
    },
    footer: {
      derechos: 'Todos los derechos reservados',
      contacto: 'Contacto',
      horario: 'Horario de Atención',
      enlaces: 'Enlaces de Interés'
    },
    accesibilidad: {
      titulo: 'Accesibilidad',
      aumentarTexto: 'Aumentar texto',
      disminuirTexto: 'Disminuir texto',
      escalaGrises: 'Escala de grises',
      altoContraste: 'Alto contraste',
      fuenteLegible: 'Fuente legible',
      subrayarEnlaces: 'Subrayar enlaces',
      restablecer: 'Restablecer'
    }
  },
  en: {
    menu: {
      inicio: 'Home',
      acerca: 'About the Council',
      noticias: 'News',
      convocatorias: 'Calls',
      gaceta: 'Gazette',
      transparencia: 'Transparency',
      contacto: 'Contact'
    },
    home: {
      titulo: 'Municipal Council of Ipiales',
      subtitulo: 'Working for our municipality',
      anuncios: 'Important Announcements',
      buscar: 'Find what you need in seconds',
      accesoRapido: 'Quick Access',
      contacto: 'Contact',
      gaceta: 'Gazette',
      noticias: 'News and Publications',
      ubicacion: 'Location Municipal Council of Ipiales'
    },
    footer: {
      derechos: 'All rights reserved',
      contacto: 'Contact',
      horario: 'Opening Hours',
      enlaces: 'Links of Interest'
    },
    accesibilidad: {
      titulo: 'Accessibility',
      aumentarTexto: 'Increase text',
      disminuirTexto: 'Decrease text',
      escalaGrises: 'Grayscale',
      altoContraste: 'High contrast',
      fuenteLegible: 'Readable font',
      subrayarEnlaces: 'Underline links',
      restablecer: 'Reset'
    }
  },
  fr: {
    menu: {
      inicio: 'Accueil',
      acerca: 'À propos du Conseil',
      noticias: 'Actualités',
      convocatorias: 'Appels',
      gaceta: 'Journal officiel',
      transparencia: 'Transparence',
      contacto: 'Contact'
    },
    home: {
      titulo: 'Conseil de Ipiales',
      subtitulo: 'Travailler pour notre municipalité',
      anuncios: 'Annonces importantes',
      buscar: 'Trouvez ce dont vous avez besoin en quelques secondes',
      accesoRapido: 'Accès rapide',
      contacto: 'Contact',
      gaceta: 'Journal officiel',
      noticias: 'Actualités et publications',
      ubicacion: 'Emplacement Conseil de Ipiales'
    },
    footer: {
      derechos: 'Tous droits réservés',
      contacto: 'Contact',
      horario: 'Heures d\'ouverture',
      enlaces: 'Liens d\'intérêt'
    },
    accesibilidad: {
      titulo: 'Accessibilité',
      aumentarTexto: 'Augmenter le texte',
      disminuirTexto: 'Diminuer le texte',
      escalaGrises: 'Niveaux de gris',
      altoContraste: 'Contraste élevé',
      fuenteLegible: 'Police lisible',
      subrayarEnlaces: 'Souligner les liens',
      restablecer: 'Réinitialiser'
    }
  },
  it: {
    menu: {
      inicio: 'Home',
      acerca: 'Info Diocese',
      noticias: 'Notizie',
      convocatorias: 'Bandi',
      gaceta: 'Gazzetta',
      transparencia: 'Trasparenza',
      contacto: 'Contatti'
    },
    home: {
      titulo: 'Diocesi di Ipiales',
      subtitulo: 'Al servizio del nostro territorio',
      anuncios: 'Annunci importanti',
      buscar: 'Trova ciò che ti serve in pochi secondi',
      accesoRapido: 'Accesso rapido',
      contacto: 'Contatti',
      gaceta: 'Gazzetta',
      noticias: 'Notizie e pubblicazioni',
      ubicacion: 'Sede della Diocesi di Ipiales'
    },
    footer: {
      derechos: 'Tutti i diritti riservati',
      contacto: 'Contatti',
      horario: 'Orario di apertura',
      enlaces: 'Link utili'
    },
    accesibilidad: {
      titulo: 'Accessibilità',
      aumentarTexto: 'Aumenta testo',
      disminuirTexto: 'Diminuisci testo',
      escalaGrises: 'Scala di grigi',
      altoContraste: 'Alto contrasto',
      fuenteLegible: 'Carattere leggibile',
      subrayarEnlaces: 'Sottolinea i link',
      restablecer: 'Reimposta'
    }
  }
};


















